import MultiFilterModal from './MultiFilterModal.component';

export default MultiFilterModal;